<div class="grid inner-scroll" fusePerfectScrollbar>

  @for (creature of items; track creature) {
    <div class="item">
      <app-gallery-thumbnail [creature]="creature" (click)="onClick(creature)"></app-gallery-thumbnail>
    </div>
  }
</div>